import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "../interfaces/pricing.interfaces";

const initialState: InitialState = {
  isLoading: false,
  data: {
    states: false,
    regions: false,
    hospitals: false,
    hospitalSystems: false,
  },
};

const saveSelectAllFromPricingFilters = createSlice({
  name: "Save the select all rom the filters",
  initialState,
  reducers: {
    updateSelectAllPricingFilters(state, action) {
      state.data = action.payload;
    },
    resetSelectAllSelection(state) {
      state.data = initialState.data;
    },
  },
});

export const { updateSelectAllPricingFilters, resetSelectAllSelection } = saveSelectAllFromPricingFilters.actions;
export default saveSelectAllFromPricingFilters.reducer;
